import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Grid,
  Box,
  Button,
  Divider,
  LinearProgress,
  Breadcrumbs,
  Container,
  Card,
  CardContent,
  CardHeader,
} from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import PostAddIcon from "@material-ui/icons/PostAdd";
import DraftsIcon from "@material-ui/icons/Drafts";
import RateReviewIcon from "@material-ui/icons/RateReview";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import PurchaseRequestFormComponent from "src/components/forms/PurchaseRequestFormComponent";
import PurchaseItemTableComponent from "src/components/tables/PurchaseItemTableComponent";

import {
  getPurchaseRequestById,
  updatePurchaseRequest,
  getYearList,
  getPurchaseDetails,
  getAllFiles,
  deleteFiles,
} from "src/redux/actions/purchaseRequest.action";

import _ from "lodash";

import { fetchUnit, fetchCurrencies } from "src/redux/actions/reference.action";

import { getBrands } from "src/redux/actions/brand.action";
import { withRouter, useParams, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Alert, AlertTitle } from "@material-ui/lab";

import moment from "moment";
import { blue, green, red, yellow } from "@material-ui/core/colors";
import Swal from "sweetalert2";
import AssignFormModal from "src/components/modals/AssignFormModal";
import ApprovalModal from "src/components/modals/ApprovalModal";
import { httpClient } from "src/utils/HttpClient";
import { hasRoleDOA, isAllowed } from "src/utils/Auth";
import Page from "src/components/Page";
import FilesUploadComponent from "src/components/FilesUploadComponent";
import MaterialTable from "material-table";
import Moment from "moment";
import Axios from "axios";
import { apiUrl, imageUrl } from "src/Constants";
import download from "js-file-download";
import { sumTotal } from "src/utils/Number";
import PermissionButton from "src/components/PermissionButton";
import { getDelegateRole } from "src/redux/actions/login.action";
import ReportPrintPurchaseRequisition from "src/components/reports/ReportPrintPurchaseRequisition";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

const PurchaseEdit = ({ history }) => {
  const classes = useStyles();

  const params = useParams();

  const dispatch = useDispatch();

  const {
    result: {
      fullname,
      countryid,
      currencyid,
      companyid,
      secureid,
      perid,
      country_code,
      currency_code,
      email,
      country,
    },
  } = useSelector((state) => state.loginReducer);

  const { authorizePR, delegateRoles } = useSelector(
    (state) => state.authorizationReducer
  );

  const {
    purchaseRequest,
    purchaseRequestDetails,
    attachFiles,
    purchaseRequesteExpense,
  } = useSelector((state) => state.purchaseRequestReducer);

  const { allDepartments, allBrands } = useSelector(
    (state) => state.referenceReducer
  );
  const { currencies } = useSelector((state) => state.referenceReducer);

  const [openModalApprove, setOpenModalApprove] = useState(false);
  const [openModalAssign, setOpenModalAssign] = useState(false);
  const [PRStatus, setPRStatus] = useState(5);
  // const [approval, setApproval] = useState({
  //   ASSIGN_APPROVE_NAME: "",
  //   ASSIGN_APPROVE_ID: null,
  //   ASSIGN_APPROVE_EMAIL: "",
  //   ASSIGN_APPROVE_DATE: null,
  // });
  const [refCountries, setRefCountries] = useState({
    REF_EX_RATE: null,
    REF_COUNTRY_NAME: "",
    REF_COUNTRYID: null,
  });

  const [POSTBY, setPOSTBY] = useState(null);

  const [year, setYear] = useState(null);
  const [assignees, setAssignees] = useState({
    ASSIGN_PURCHASE_NAME: "",
    ASSIGN_PURCHASE_ID: "",
    ASSIGN_PURCHASE_EMAIL: "",
  });

  useEffect(() => {
    dispatch(getPurchaseRequestById(params.id));
    dispatch(getPurchaseDetails(params.id));
    dispatch(getAllFiles(params.id));
    if (purchaseRequest.data) {
      dispatch(getYearList());
      const { PR_YEAR } = purchaseRequest.data;
      setYear(PR_YEAR);
      dispatch(fetchUnit());
      dispatch(fetchCurrencies(currencyid));
      dispatch(getBrands(countryid, companyid, secureid));
    }

    return () => {};
  }, [currencyid, dispatch, params.id]);

  useEffect(() => {
    dispatch(getDelegateRole(perid, params.id));
    return () => {};
  }, [perid, params.id]);

  const handleCloseModalApprove = () => {
    setOpenModalApprove(false);
  };

  let submitPurchaseRequestForm = null;

  const handleSubmitMyForm = (e, status) => {
    if (submitPurchaseRequestForm) {
      submitPurchaseRequestForm(e, status);
    }
  };

  const bindSubmitForm = (submitForm) => {
    submitPurchaseRequestForm = submitForm;
  };

  const handleSubmitForm = (values) => {
    let data = {};

    if (PRStatus) {
      data = {
        ...values,
        PR_STATUS: PRStatus,
      };
    } else {
      data = values;
    }

    const { PRHIDX } = values;
    delete data.PRHIDX;
    delete data.CREATED_DATE;
    delete data.UPDATED_AT;

    if (PRStatus === 20) {
      data.COUNTRY_CODE = country_code;
      // data.ASSIGN_APPROVE_ID = approval.ASSIGN_APPROVE_ID;
      // data.ASSIGN_APPROVE_NAME = approval.ASSIGN_APPROVE_NAME;
      // data.ASSIGN_APPROVE_EMAIL = approval.ASSIGN_APPROVE_EMAIL;
      // data.ASSIGN_APPROVE_DATE = approval.ASSIGN_APPROVE_DATE;
      data.REF_EX_RATE = refCountries.REF_EX_RATE;
      data.REF_COUNTRY_NAME = refCountries.REF_COUNTRY_NAME;
      data.REF_COUNTRYID = refCountries.REF_COUNTRYID;

      data.POSTED_NAME = POSTBY;
      data.POSTED_EMAIL = email;
      data.POSTED_DATE = moment().format("YYYY-MM-DD HH:mm:ss");
      data.POSTED_ID = perid;
    }

    if (PRStatus === 50) {
      data.ASSIGN_PURCHASE_NAME = assignees.ASSIGN_PURCHASE_NAME;
      data.ASSIGN_PURCHASE_ID = assignees.ASSIGN_PURCHASE_ID;
      data.ASSIGN_PURCHASE_EMAIL = assignees.ASSIGN_PURCHASE_EMAIL;
      data.ASSIGN_DATE = moment().format("YYYY-MM-DD HH:mm:ss");
    }

    if (data.PR_TYPE !== 2) {
      data.REF_PR_NO = null;
    }

    dispatch(updatePurchaseRequest(PRHIDX, data, history));
  };

  const renderForm = () => {
    return (
      <div>
        {purchaseRequest.isLoading && <LinearProgress color="secondary" />}
        <PurchaseRequestFormComponent
          bindSubmitForm={bindSubmitForm}
          initialValues={purchaseRequest.data}
          handleSubmitForm={handleSubmitForm}
        />
      </div>
    );
  };

  const ctrlCopyButton = () => {
    if (purchaseRequestDetails.data && purchaseRequest.data) {
      if (
        purchaseRequest.data.PR_STATUS === 5 ||
        purchaseRequest.data.PR_STATUS === 10 ||
        purchaseRequest.data.PR_TYPE === 2 ||
        purchaseRequest.data.REF_CODE !== null
      ) {
        return true;
      }
    }
    return false;
  };

  const ctrlDraftButton = () => {
    if (purchaseRequest.data) {
      if (purchaseRequest.data.PR_STATUS >= 10) {
        return true;
      }
    }

    return false;
  };

  const ctrlCancelButton = () => {
    if (purchaseRequest.data) {
      if (purchaseRequest.data.PR_STATUS >= 20) {
        return true;
      }
    }

    return false;
  };

  const ctrlAssignButton = () => {
    if (purchaseRequest.data) {
      if (purchaseRequest.data.PR_STATUS === 30) {
        return false;
      }
    }

    return true;
  };

  const ctrlReceiveButton = () => {
    if (purchaseRequest.data) {
      if (purchaseRequest.data.PR_STATUS === 30) {
        return false;
      }
    }

    return true;
  };

  const ctrlRejectButton = () => {
    if (purchaseRequest.data) {
      if (purchaseRequest.data.PR_STATUS === 30) {
        return false;
      }
    }

    return true;
  };

  const ctrlAttachfile = () => {
    if (purchaseRequest.data) {
      if (purchaseRequest.data.PR_STATUS === 10) {
        return true;
      }
      if (purchaseRequest.data.PR_STATUS === 70) {
        return true;
      }
    }

    return false;
  };

  const print = () => {
    httpClient
      .get(`${apiUrl}/purchase-request/purchase-print?id=${params.id}`)
      .then(({ data }) => {
        const {
          PR_NO,
          CREATED_DATE,
          PR_STATUS,
          POST_DATE,
          REMARK,
          REF_PR_NO,
          UPDATED_AT,
          POSTED_EMAIL,
          POSTED_NAME,
          PRINT_TIME,
          ASSIGN_APPROVE_NAME,
          POSTED_DATE,
          PR_BRANDID_NAME,
          PR_DEPARTID_NAME,
          APPROVED_DATE,
          REQUESTOR_TITLE,
          REQUESTOR_DOA_LEVEL,
          REVIEWER_TITLE,
          REVIEWER_DOA_LEVEL,
          APPROVER_TITLE,
          APPROVER_DOA_LEVEL,
          REVIEWER_NAME,
          REVIEWER_REVIEWED_DATE,
        } = data;
        let headers = {};
        let ExpenseAmount = 0;
        if (purchaseRequesteExpense.data) {
          const { AMOUNT } = purchaseRequesteExpense.data;
          ExpenseAmount = AMOUNT;
        }
        headers.REQUESTER = POSTED_NAME;
        headers.REQUESTED_DATE =
          PR_STATUS === 10
            ? Moment().format("DD-MM-YYYY HH:mm:ss")
            : Moment.utc(POSTED_DATE)
                .local("Asia/Bangkok")
                .format("DD-MM-YYYY HH:mm:ss");

        headers.EMAIL = POSTED_EMAIL;
        headers.COMPANY = country;
        headers.PR_NO = PR_NO;
        headers.REF_PR_NO = REF_PR_NO;
        headers.CREATED_DATE = CREATED_DATE;
        headers.UPDATED_AT = UPDATED_AT;
        headers.PR_STATUS = PR_STATUS;
        headers.POST_DATE = POST_DATE;
        headers.BUDGET_AMOUNT_CURRENCY = currency_code;
        headers.BRAND_NAME = PR_BRANDID_NAME;
        headers.DEPARTMENT = PR_DEPARTID_NAME;
        headers.REQUESTOR_TITLE = REQUESTOR_TITLE;
        headers.REQUESTOR_DOA_LEVEL = REQUESTOR_DOA_LEVEL;

        if (
          [
            22, 30, 35, 50, 51, 52, 49, 53, 54, 55, 56, 57, 59, 70, 60, 100,
          ].includes(PR_STATUS)
        ) {
          headers.REVIEWER_TITLE = REVIEWER_TITLE;
          headers.REVIEWER_DOA_LEVEL = REVIEWER_DOA_LEVEL;
          headers.REVIEWER_NAME = REVIEWER_NAME;
          headers.REVIEWER_REVIEWED_DATE = REVIEWER_REVIEWED_DATE
            ? Moment.utc(REVIEWER_REVIEWED_DATE)
                .local("Asia/Bangkok")
                .format("DD-MM-YYYY HH:mm:ss")
            : "";
        } else {
          headers.REVIEWER_TITLE = "";
          headers.REVIEWER_DOA_LEVEL = "";
          headers.REVIEWER_NAME = "...........................................";
          headers.REVIEWER_REVIEWED_DATE =
            "...........................................";
        }

        if (
          [30, 50, 51, 52, 49, 53, 54, 55, 56, 57, 59, 70, 60, 100].includes(
            PR_STATUS
          )
        ) {
          headers.APPROVER_TITLE = APPROVER_TITLE;
          headers.APPROVER_DOA_LEVEL = APPROVER_DOA_LEVEL;
          headers.ASSIGN_APPROVE_NAME = ASSIGN_APPROVE_NAME
            ? ASSIGN_APPROVE_NAME
            : "";
          headers.APPROVED_DATE =
            PR_STATUS === 30
              ? Moment.utc(APPROVED_DATE)
                  .local("Asia/Bangkok")
                  .format("DD-MM-YYYY HH:mm:ss")
              : "";
        } else {
          headers.APPROVER_TITLE = "";
          headers.APPROVER_DOA_LEVEL = "";
          headers.ASSIGN_APPROVE_NAME =
            "...........................................";
          headers.APPROVED_DATE = "...........................................";
        }

        let baseCurrency = 1;
        let result = _.find(currencies.data, {
          CURRENCY_ID: currencyid,
        });
        if (result) {
          baseCurrency = result.CURRENCY_EXC_ID;
        }
        headers.PRINT_TYPE = "";
        if ([10, 20, 6].includes(PR_STATUS)) {
          headers.WATERMARK = "DRAFT";
        } else {
          if (PRINT_TIME === 1) {
            headers.PRINT_TYPE = "(Original)";
          } else {
            headers.PRINT_TYPE = `(Re-Print)`;
          }
          headers.WATERMARK = "";
        }
        let footers = {};
        footers.REMARK = REMARK;
        let rows = purchaseRequestDetails.data.map((i) => {
          let brandItem = allBrands.data.find((e) => {
            return e.REF_ID === i.PR_BRANDID;
          });
          let departmentItem = allDepartments.data.find((e) => {
            return e.REF_ID === i.PR_DEPARTID;
          });
          return {
            ...i,
            BUDGET_AMOUNT: baseCurrency * i.PRICE * i.QTY,
            BRAND_NAME: brandItem.REF_NAME,
            DEPARTMENT_NAME: departmentItem.REF_NAME,
          };
        });
        ReportPrintPurchaseRequisition(
          rows,
          allDepartments.data,
          ExpenseAmount,
          headers,
          footers,
          baseCurrency,
          currencies.data
        );
      })
      .catch((err) => {
        Swal.fire("The system has error.", err.message, "error");
      });
  };

  const renderTableProduct = () => {
    if (purchaseRequest.isLoading) {
      return (
        <div className={classes.root}>
          <LinearProgress color="secondary" />
        </div>
      );
    }

    if (purchaseRequest.data && purchaseRequest.data.PR_YEAR) {
      const { PR_BRANDID, PR_DEPARTID, PR_STATUS, PR_YEAR } =
        purchaseRequest.data;

      return (
        <>
          <PurchaseItemTableComponent
            headerData={purchaseRequest.data}
            status={PR_STATUS}
            departid={PR_DEPARTID}
            brandid={PR_BRANDID}
            companyid={companyid}
            year={year ? year : PR_YEAR}
            updateStatus={(e) => {
              if (!e) e = window.event;
              setPRStatus(10);
              handleSubmitMyForm(e);
            }}
            headerId={params.id}
          />
        </>
      );
    }

    return (
      <div style={{ margin: 10 }}>
        <Alert severity="warning">
          <AlertTitle></AlertTitle>
          Please save draft before choose the item
        </Alert>
      </div>
    );
  };

  if (purchaseRequest.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert — <strong>Get Purchase request detail!</strong>
        </Alert>
      </div>
    );
  }

  return (
    <Page
      className={classes.root}
      title={`Purchase Requisition Form : ${
        purchaseRequest.data && purchaseRequest.data.PR_NO
          ? purchaseRequest.data.PR_NO
          : "New PR"
      }`}
    >
      <Container maxWidth={false}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            onClick={() => {
              // history.replace("/purchase-requisition-list");
              history.goBack();
            }}
          >
            Purchase Requisition List
          </Link>
          <Link color="textPrimary" aria-current="page">
            Purchase Requisition Form (
            {purchaseRequest.data && purchaseRequest.data.PR_NO
              ? purchaseRequest.data.PR_NO
              : "New PR"}
            )
          </Link>
        </Breadcrumbs>
        <Card>
          <CardHeader
            subheader="For the purchase requisition on the system."
            title="Purchase Requesition Form"
          />
          <Divider />
          <CardContent>
            {renderForm()}
            {renderTableProduct()}
            <Divider />
            {ctrlAttachfile() && (
              <FilesUploadComponent
                headerId={params.id}
                handleUpload={() => {
                  dispatch(getAllFiles(params.id));
                }}
              />
            )}
            <MaterialTable
              columns={[
                {
                  title: "File Name",
                  field: "ATT_FILENAME",
                  render: (rowData) => {
                    return (
                      <>
                        <AttachFileIcon />
                        {rowData.ATT_FILENAME}
                      </>
                    );
                  },
                },
                {
                  title: "Date Uploaded",
                  field: "CREATED_DATE",
                  type: "date",
                  render: (rowData) =>
                    Moment(rowData.CREATED_DATE).format("DD-MMM-YY"),
                },
                {
                  title: "Download",
                  field: "ATTIDX",
                  render: (rowData) => (
                    <CloudDownloadIcon
                      onClick={() => {
                        Axios({
                          url: `${imageUrl}/upload/purchase-files/${rowData.ATT_FILENAME}`,
                          method: "GET",
                          responseType: "blob",
                        })
                          .then((res) => {
                            download(res.data, rowData.ATT_FILENAME);
                          })
                          .catch((err) => {
                            Swal.fire(
                              "The system has error.",
                              err.message,
                              "error"
                            );
                          });
                      }}
                    />
                  ),
                },
              ]}
              data={attachFiles.data}
              editable={{
                isDeletable: () => {
                  return ctrlAttachfile();
                },
                onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    setTimeout(() => {
                      dispatch(deleteFiles(oldData.ATTIDX, params.id));
                      resolve();
                    }, 1000);
                  }),
              }}
              options={{
                showTitle: false,
                search: false,
                padding: false,
              }}
            />
            <Divider />
            <Grid item xs={12} sm={12}>
              <Box display="flex" component="div">
                <Box p={1} flexGrow={1}>
                  {isAllowed(authorizePR.data, ["can_print"]) &&
                    purchaseRequest.data &&
                    ![5, 24, 40, 58, 80].includes(
                      purchaseRequest.data.PR_STATUS
                    ) && (
                      <Button
                        variant="outlined"
                        onClick={(e) => {
                          Swal.fire({
                            title: "Confirm print to the purchase requisition",
                            showCancelButton: true,
                            icon: "warning",
                            confirmButtonText: "Yes, Print",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              const { PRINT_TIME, PR_STATUS } =
                                purchaseRequest.data;

                              if (PR_STATUS === 10) {
                                print();
                              } else {
                                httpClient
                                  .put(`/purchase-request/print/${params.id}`, {
                                    PRINT_TIME: PRINT_TIME + 1,
                                  })
                                  .then(() => {
                                    print();
                                  })
                                  .catch((error) => {
                                    Swal.showValidationMessage(
                                      `Request failed: ${error}`
                                    );
                                  });
                              }
                            }
                          });
                        }}
                      >
                        <PrintIcon /> Print
                      </Button>
                    )}
                  <Button
                    variant="contained"
                    disabled={ctrlCopyButton()}
                    onClick={(e) => {
                      e.preventDefault();
                      Swal.fire({
                        title:
                          "Please confirm to copy to the purchase requisition ?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          httpClient
                            .put(
                              `${apiUrl}/purchase-request/find-copies/${params.id}`
                            )
                            .then((result) => {
                              history.replace(`/purchase-requisition-list`);
                            })
                            .catch((err) => {
                              Swal.showValidationMessage(
                                `Request failed: ${err}`
                              );
                            });
                        }
                      });
                    }}
                    style={{
                      backgroundColor: blue[500],
                    }}
                  >
                    <FileCopyIcon />
                    Copy
                  </Button>
                </Box>
                <Box p={1}>
                  {isAllowed(authorizePR.data, ["can_staff_reject"]) && (
                    <Button
                      variant="contained"
                      disabled={ctrlRejectButton()}
                      onClick={(e) => {
                        e.preventDefault();
                        Swal.fire({
                          title: "Submit your remark for reject",
                          input: "textarea",
                          inputAttributes: {
                            autocapitalize: "off",
                          },
                          showCancelButton: true,
                          confirmButtonText: "Rejected",
                          showLoaderOnConfirm: true,
                          inputValidator: (value) => {
                            return new Promise((resolve) => {
                              if (value) {
                                resolve();
                              } else {
                                resolve("Please fill to remark for reject !");
                              }
                            });
                          },
                          preConfirm: (remark) => {
                            return httpClient
                              .put(`/purchase-request/update/${params.id}`, {
                                PR_H_REMARKs: {
                                  REMARK_TEXT: remark,
                                },
                                ASSIGN_PURCHASE_NAME: fullname,
                                ASSIGN_PURCHASE_ID: perid,
                                PR_STATUS: 80,
                                PR_TYPE: purchaseRequest.data.PR_TYPE,
                                REF_PR_NO: purchaseRequest.data.REF_PR_NO,
                              })
                              .then((result) => {
                                return result.data;
                              })
                              .catch((error) => {
                                Swal.showValidationMessage(
                                  `Request failed: ${error}`
                                );
                              });
                          },
                          allowOutsideClick: () => !Swal.isLoading(),
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire({
                              text: `The Purchase Requesition Job (${
                                purchaseRequest.data &&
                                purchaseRequest.data.PR_NO
                              }) has rejected`,
                              icon: "success",
                            }).then(() => {
                              history.goBack();
                            });
                          }
                        });
                      }}
                      style={{
                        backgroundColor: red[500],
                      }}
                    >
                      <PostAddIcon />
                      Rejected
                    </Button>
                  )}
                  {isAllowed(authorizePR.data, ["can_staff_receive"]) &&
                    purchaseRequest.data &&
                    purchaseRequest.data.REF_COUNTRYID === null && (
                      <Button
                        variant="contained"
                        disabled={ctrlReceiveButton()}
                        onClick={(e) => {
                          e.preventDefault();
                          Swal.fire({
                            title: "Confirm to receive ?",
                            text: "You won't be able to revert this!",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              setPRStatus(50);
                              setAssignees({
                                ASSIGN_PURCHASE_NAME: fullname,
                                ASSIGN_PURCHASE_ID: perid,
                                ASSIGN_PURCHASE_EMAIL: email,
                              });
                              handleSubmitMyForm(e);
                            }
                          });
                        }}
                        style={{
                          backgroundColor: green[200],
                        }}
                      >
                        <RateReviewIcon />
                        Receive
                      </Button>
                    )}
                  {isAllowed(authorizePR.data, ["can_staff_assign"]) &&
                    purchaseRequest.data &&
                    purchaseRequest.data.REF_COUNTRYID === null &&
                    [50, 51, 53].includes(purchaseRequest.data.PR_STATUS) && (
                      <Button
                        variant="contained"
                        disabled={ctrlAssignButton()}
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenModalAssign(true);
                        }}
                        style={{
                          backgroundColor: green[200],
                        }}
                      >
                        <AssignmentTurnedInIcon />
                        Assign
                      </Button>
                    )}
                  {hasRoleDOA(delegateRoles.data, ["delegatedApprover"]) &&
                    purchaseRequest.data &&
                    purchaseRequest.data.PR_STATUS !== 30 && (
                      <PermissionButton
                        type="ManagerApprove"
                        onClick={(e) => {
                          e.preventDefault();
                          Swal.fire({
                            title: "Confirm to approve ?",
                            text: "You won't be able to revert this!",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              dispatch(
                                updatePurchaseRequest(
                                  params.id,
                                  {
                                    PR_STATUS: 30,
                                    APPROVED_DATE: moment().format(
                                      "YYYY-MM-DD HH:mm:ss"
                                    ),
                                    PRINT_TIME: 0,
                                    ASSIGN_APPROVE_NAME: fullname,
                                    ASSIGN_APPROVE_ID: perid,
                                    ASSIGN_APPROVE_EMAIL: email,
                                  },
                                  history
                                )
                              );
                            }
                          });
                        }}
                        style={{
                          backgroundColor: green[500],
                        }}
                        // status={purchaseRequest.data.PR_STATUS}
                        status={22}
                        title="Approver Approved"
                      >
                        <ThumbUpIcon />
                      </PermissionButton>
                    )}
                  {hasRoleDOA(delegateRoles.data, ["delegatedApprover"]) &&
                    purchaseRequest.data &&
                    purchaseRequest.data.PR_STATUS !== 35 && (
                      <PermissionButton
                        style={{
                          backgroundColor: yellow[500],
                        }}
                        onClick={() => {
                          Swal.fire({
                            title: "Submit your remark for hold",
                            input: "textarea",
                            inputAttributes: {
                              autocapitalize: "off",
                            },
                            showCancelButton: true,
                            confirmButtonText: "Approver Hold",
                            showLoaderOnConfirm: true,
                            inputValidator: (value) => {
                              return new Promise((resolve) => {
                                if (value) {
                                  resolve();
                                } else {
                                  resolve("Please fill to remark for Hold !");
                                }
                              });
                            },
                            preConfirm: (remark) => {
                              return httpClient
                                .put(`/purchase-request/update/${params.id}`, {
                                  PR_H_REMARKs: {
                                    REMARK_TEXT: remark,
                                  },
                                  PR_STATUS: 35,
                                  APPROVED_DATE: moment().format(
                                    "YYYY-MM-DD HH:mm:ss"
                                  ),
                                  PRINT_TIME: 0,
                                  ASSIGN_APPROVE_NAME: fullname,
                                  ASSIGN_APPROVE_ID: perid,
                                  ASSIGN_APPROVE_EMAIL: email,
                                })
                                .then((result) => {
                                  return result.data;
                                })
                                .catch((error) => {
                                  Swal.showValidationMessage(
                                    `Request failed: ${error}`
                                  );
                                });
                            },
                            allowOutsideClick: () => !Swal.isLoading(),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire({
                                text: `The Purchase Requesition Job (${
                                  purchaseRequest.data &&
                                  purchaseRequest.data.PR_NO
                                }) has Approver Hold`,
                                icon: "success",
                              }).then(() => {
                                history.goBack();
                              });
                            }
                          });
                        }}
                        type="ManagerHold"
                        status={22}
                        title="Approver Hold"
                      />
                    )}
                  {hasRoleDOA(delegateRoles.data, ["delegatedApprover"]) &&
                    purchaseRequest.data &&
                    purchaseRequest.data.PR_STATUS !== 40 && (
                      <PermissionButton
                        style={{
                          backgroundColor: red[500],
                        }}
                        onClick={() => {
                          Swal.fire({
                            title: "Submit your remark for reject",
                            input: "textarea",
                            inputAttributes: {
                              autocapitalize: "off",
                            },
                            showCancelButton: true,
                            confirmButtonText: "Rejected",
                            showLoaderOnConfirm: true,
                            inputValidator: (value) => {
                              return new Promise((resolve) => {
                                if (value) {
                                  resolve();
                                } else {
                                  resolve("Please fill to remark for reject !");
                                }
                              });
                            },
                            preConfirm: (remark) => {
                              return httpClient
                                .put(`/purchase-request/update/${params.id}`, {
                                  PR_H_REMARKs: {
                                    REMARK_TEXT: remark,
                                  },
                                  PR_STATUS: 40,
                                  ASSIGN_APPROVE_ID: perid,
                                  ASSIGN_APPROVE_NAME: fullname,
                                  ASSIGN_APPROVE_EMAIL: email,
                                  PR_TYPE: purchaseRequest.data.PR_TYPE,
                                  REF_PR_NO: purchaseRequest.data.REF_PR_NO,
                                })
                                .then((result) => {
                                  return result.data;
                                })
                                .catch((error) => {
                                  Swal.showValidationMessage(
                                    `Request failed: ${error}`
                                  );
                                });
                            },
                            allowOutsideClick: () => !Swal.isLoading(),
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire({
                                text: `The Purchase Requesition Job (${
                                  purchaseRequest.data &&
                                  purchaseRequest.data.PR_NO
                                }) has rejected`,
                                icon: "success",
                              }).then(() => {
                                history.goBack();
                              });
                            }
                          });
                        }}
                        type="ManagerReject"
                        // status={purchaseRequest.data.PR_STATUS}
                        status={22}
                        title="Approver Reject"
                      >
                        <ThumbDownIcon />
                      </PermissionButton>
                    )}
                  {isAllowed(authorizePR.data, ["can_draft"]) &&
                    purchaseRequest.data &&
                    purchaseRequest.data.PR_STATUS === 5 && (
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: green[600],
                          color: !ctrlDraftButton() && "white",
                        }}
                        onClick={(e) => {
                          setPRStatus(10);
                          handleSubmitMyForm(e);
                        }}
                        disabled={ctrlDraftButton()}
                      >
                        <DraftsIcon />
                        SAVE DRAFT
                      </Button>
                    )}
                  {isAllowed(authorizePR.data, ["can_post"]) &&
                    purchaseRequest.data &&
                    purchaseRequest.data.PR_STATUS === 10 && (
                      <Button
                        variant="contained"
                        onClick={(e) => {
                          e.preventDefault();
                          if (
                            sumTotal(["AMOUNT"], purchaseRequestDetails.data) >
                            0
                          ) {
                            if (purchaseRequest.data.PR_TYPE === 1) {
                              httpClient
                                .get(
                                  `/purchase-request/avg-expense/${params.id}/${purchaseRequest.data.PR_YEAR}/${purchaseRequest.data.PR_COMPIDX}`
                                )
                                .then((result) => {
                                  if (result.data) {
                                    const { icon, message } = result.data;
                                    if (icon === "success") {
                                      setPOSTBY(fullname);
                                      setOpenModalApprove(true);
                                      // handleSubmitMyForm(window.event);
                                    } else if (icon === "warning") {
                                      Swal.fire({
                                        title: "Warning",
                                        text: message,
                                        icon: "warning",
                                      });
                                    }
                                  }
                                })
                                .catch((error) => {
                                  Swal.showValidationMessage(
                                    `Request failed: ${error}`
                                  );
                                });
                            } else {
                              setPOSTBY(fullname);
                              setOpenModalApprove(true);
                              // handleSubmitMyForm(window.event);
                            }
                          } else {
                            Swal.fire({
                              title: "Warning!",
                              text: "Please enter your item quantity or price.",
                              icon: "warning",
                            });
                          }
                        }}
                        color="primary"
                      >
                        <PostAddIcon />
                        Post
                      </Button>
                    )}
                  {isAllowed(authorizePR.data, ["can_cancel"]) && (
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: yellow[600],
                      }}
                      disabled={ctrlCancelButton()}
                      onClick={(e) => {
                        e.preventDefault();
                        Swal.fire({
                          title: "Confirm to cancel ?",
                          text: "You won't be able to revert this!",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Yes",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            setPRStatus(0);
                            dispatch(
                              updatePurchaseRequest(
                                params.id,
                                {
                                  PR_STATUS: 0,
                                },
                                history
                              )
                            );
                          }
                        });
                      }}
                    >
                      <DraftsIcon />
                      Cancel
                    </Button>
                  )}
                  {hasRoleDOA(delegateRoles.data, ["delegatedReviewer"]) &&
                    purchaseRequest.data && (
                      <>
                        {purchaseRequest.data.PR_STATUS !== 22 && (
                          <PermissionButton
                            color="primary"
                            type="ReviewerReview"
                            onClick={() => {
                              Swal.fire({
                                title: "Confirm to reviewed ?",
                                text: "Do you have been reviewed the purchase requisition?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Yes",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  dispatch(
                                    updatePurchaseRequest(
                                      params.id,
                                      {
                                        PR_STATUS: 22,
                                        REVIEWER_NAME: fullname,
                                        REVIEWER_EMAIL: email,
                                        REVIEWER_ID: perid,
                                        REVIEWER_REVIEWED_DATE: moment().format(
                                          "YYYY-MM-DD HH:mm:ss"
                                        ),
                                      },
                                      history
                                    )
                                  );
                                }
                              });
                            }}
                            // status={purchaseRequest.data.PR_STATUS}
                            status={20}
                            title="Reviewed"
                          >
                            <RateReviewIcon />
                          </PermissionButton>
                        )}
                        {purchaseRequest.data.PR_STATUS !== 24 &&
                          purchaseRequest.data.PR_STATUS !== 22 && (
                            <PermissionButton
                              color="primary"
                              type="ReviewerRejected"
                              onClick={() => {
                                Swal.fire({
                                  title: "Submit your remark for reject",
                                  input: "textarea",
                                  inputAttributes: {
                                    autocapitalize: "off",
                                  },
                                  showCancelButton: true,
                                  confirmButtonText: "Rejected",
                                  showLoaderOnConfirm: true,
                                  inputValidator: (value) => {
                                    return new Promise((resolve) => {
                                      if (value) {
                                        resolve();
                                      } else {
                                        resolve(
                                          "Please fill to remark for reject !"
                                        );
                                      }
                                    });
                                  },
                                  preConfirm: (remark) => {
                                    return httpClient
                                      .put(
                                        `/purchase-request/update/${params.id}`,
                                        {
                                          PR_H_REMARKs: {
                                            REMARK_TEXT: remark,
                                          },
                                          PR_STATUS: 24,
                                          REVIEWER_NAME: fullname,
                                          REVIEWER_EMAIL: email,
                                          REVIEWER_ID: perid,
                                          PR_TYPE: purchaseRequest.data.PR_TYPE,
                                          REF_PR_NO:
                                            purchaseRequest.data.REF_PR_NO,
                                          REVIEWER_REJECTED_DATE:
                                            moment().format(
                                              "YYYY-MM-DD HH:mm:ss"
                                            ),
                                        }
                                      )
                                      .then((result) => {
                                        return result.data;
                                      })
                                      .catch((error) => {
                                        Swal.showValidationMessage(
                                          `Request failed: ${error}`
                                        );
                                      });
                                  },
                                  allowOutsideClick: () => !Swal.isLoading(),
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    Swal.fire({
                                      text: `The Purchase Requesition (${
                                        purchaseRequest.data &&
                                        purchaseRequest.data.PR_NO
                                      }) has rejected`,
                                      icon: "success",
                                    }).then(() => {
                                      history.goBack();
                                    });
                                  }
                                });
                              }}
                              status={20}
                              title="Reviewer Rejected"
                              style={{
                                backgroundColor: red[500],
                              }}
                            />
                          )}
                        {purchaseRequest.data.PR_STATUS !== 26 &&
                          purchaseRequest.data.PR_STATUS !== 22 &&
                          purchaseRequest.data.PR_STATUS !== 24 && (
                            <PermissionButton
                              type="ReviewerHold"
                              onClick={() => {
                                Swal.fire({
                                  title: "Input Box Reason to Hold",
                                  input: "textarea",
                                  inputAttributes: {
                                    autocapitalize: "off",
                                  },
                                  showCancelButton: true,
                                  confirmButtonText: "Reviewer Hold",
                                  showLoaderOnConfirm: true,
                                  inputValidator: (value) => {
                                    return new Promise((resolve) => {
                                      if (value) {
                                        resolve();
                                      } else {
                                        resolve(
                                          "Please fill to remark for hold !"
                                        );
                                      }
                                    });
                                  },
                                  preConfirm: (remark) => {
                                    return httpClient
                                      .put(
                                        `/purchase-request/update/${params.id}`,
                                        {
                                          PR_H_REMARKs: {
                                            REMARK_TEXT: remark,
                                          },
                                          PR_STATUS: 26,
                                          REVIEWER_NAME: fullname,
                                          REVIEWER_EMAIL: email,
                                          REVIEWER_ID: perid,
                                          PR_TYPE: purchaseRequest.data.PR_TYPE,
                                          REF_PR_NO:
                                            purchaseRequest.data.REF_PR_NO,
                                        }
                                      )
                                      .then((result) => {
                                        return result.data;
                                      })
                                      .catch((error) => {
                                        Swal.showValidationMessage(
                                          `Request failed: ${error}`
                                        );
                                      });
                                  },
                                  allowOutsideClick: () => !Swal.isLoading(),
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    Swal.fire({
                                      text: `The Purchase Requesition (${
                                        purchaseRequest.data &&
                                        purchaseRequest.data.PR_NO
                                      }) has Held By Reviewer`,
                                      icon: "success",
                                    }).then(() => {
                                      history.goBack();
                                    });
                                  }
                                });
                              }}
                              status={20}
                              title="Reviewer Hold"
                              style={{
                                backgroundColor: yellow[600],
                              }}
                            />
                          )}
                      </>
                    )}
                  <Button
                    onClick={() => {
                      // history.replace(`/purchase-requisition-list`)
                      history.goBack();
                    }}
                    variant="contained"
                  >
                    BACK
                  </Button>
                </Box>
              </Box>
            </Grid>
            <ApprovalModal
              openModalApprove={openModalApprove}
              handleCloseModalApprove={handleCloseModalApprove}
              handleSubmitApproval={(approval, countries) => {
                if (countries) {
                  const { ORG_COUNTRY_ID, COUNTRY, CURRENCY_EXC } = countries;

                  setRefCountries({
                    REF_EX_RATE: CURRENCY_EXC,
                    REF_COUNTRY_NAME: COUNTRY,
                    REF_COUNTRYID: ORG_COUNTRY_ID,
                  });
                }

                setPRStatus(20);
                handleSubmitMyForm(window.event);
                setOpenModalApprove(false);
              }}
              perid={perid}
            />
            <AssignFormModal
              openModal={openModalAssign}
              handleCloseModal={() => {
                setOpenModalAssign(false);
              }}
              handleSubmit={(value) => {
                setAssignees({
                  ASSIGN_PURCHASE_NAME: `${value.PER_FIRSTNAME} ${value.PER_SURNAME}`,
                  ASSIGN_PURCHASE_ID: value.PER_ID,
                  ASSIGN_PURCHASE_EMAIL: value.PER_EMAIL,
                });
                setPRStatus(50);
                handleSubmitMyForm(window.event);
              }}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default withRouter(PurchaseEdit);
